import { render, staticRenderFns } from "./SectionResource.vue?vue&type=template&id=54adc85b&scoped=true"
import script from "./SectionResource.vue?vue&type=script&lang=ts"
export * from "./SectionResource.vue?vue&type=script&lang=ts"
import style0 from "./SectionResource.vue?vue&type=style&index=0&id=54adc85b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54adc85b",
  null
  
)

export default component.exports